import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/safety", label: "Safety" },
  { to: "/support", label: "Support" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const scrollDownload = () => {
    const el = document.getElementById("download");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "crystal border-b border-black/[0.06]" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Logo />

        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors hover:text-aura-ink ${
                  isActive ? "text-aura-ink" : "text-aura-text2"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/#download"
            data-testid="nav-get-app"
            onClick={scrollDownload}
            className="rounded-full bg-aura-ink px-5 py-2.5 text-sm font-semibold text-white transition-all hover:bg-aura-ink2 hover:-translate-y-0.5"
          >
            Download app
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="grid h-10 w-10 place-items-center rounded-full border border-black/10 text-aura-ink md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="crystal border-t border-black/[0.06] md:hidden">
          <div className="flex flex-col gap-1 px-6 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-xl px-3 py-3 text-base font-semibold ${
                    isActive ? "bg-black/5 text-aura-ink" : "text-aura-text2"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/#download"
              onClick={() => {
                setOpen(false);
                setTimeout(scrollDownload, 100);
              }}
              className="mt-2 rounded-full bg-aura-ink px-5 py-3 text-center text-base font-semibold text-white"
            >
              Download app
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
